import React, { useState } from "react";
import { Pen } from "lucide-react";
import ToggleSwitch from "../../../ui/ToggleSwitch";
import CustomModal from "../../../ui/CustomModal";
import UpdateExtraItemForm from "../form/UpdateExtraItemForm";
import { useTranslation } from "react-i18next";
import { Extra } from "../../../../types/modules/product.type";
import i18next from "i18next";
import { useParams } from "react-router-dom";
import { useUpdateResource } from "../../../../hooks/useUpdateResource";
import { formatNumber } from "../../../../utils/formatNumber";
import { PermissionGate } from "../../../admin/PermissionGate";
import { PermissionsKey } from "../../../../data/permissions";


type Props={
  extra:Extra
}

function ExtraItemBox({extra}:Props) {
          const [isOpen, setIsOpen] = useState(false);
          const {t} = useTranslation();
          const enName = extra.languages.find(s=>s.languageCode==="en")?.name ||"";
          const arName = extra.languages.find(s=>s.languageCode==="ar")?.name ||"";
          const { productId ,storeId} = useParams<{ productId: string , storeId:string }>();
          const numericProductId = productId ? parseInt(productId) : 0;
          const numericStoreId = storeId ? parseInt(storeId) : undefined;
          const [isActive, setIsActive]= useState(extra.isActive);
          const {updateResource} = useUpdateResource();

          async function handleChangeActive(){
            setIsActive(p=>!p);
            const endPoint = numericStoreId ? `product-extra/active/${extra.id}?storeId=${numericStoreId}` :`product-extra/active/${extra.id}`
            await  updateResource(endPoint, {}, numericStoreId ?  "admin": "store",{
                method: "PUT",
                invalidateQueries:["product-detail"],
          });
          }


    
  return (
    <div className="flex items-center justify-between py-4 w-[330px] max-w-full">
      {/* Left side: Title */}
      <div>
        <h3 className="font-medium text-sm text-Black">{extra.languages.find(e=>e.languageCode===i18next.language)?.name}</h3>
      </div>

      {/* Right side: Price + Edit + Toggle */}
      <div className="flex items-center gap-4">
        {/* Price */}
        <div className="flex gap-1 items-center">
          <img src="/vector2.png" alt="" className="w-[10.67px] h-[11.95px]" />
          <p className="text-Black text-[16px] font-black">{formatNumber(extra.additionalPrice)}</p>
        </div>

        <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
          <>
          {/* Edit Button */}
          <button
          onClick={()=>setIsOpen(true)}
          className="text-primaryButton hover:underline flex items-center gap-1">
            <Pen size={16} />
          </button>

          {/* Toggle Switch */}
          <ToggleSwitch checked={isActive} onChange={handleChangeActive} size="sm" />
          </>
        </PermissionGate>
      </div>
      <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_extra_item')}
        >
        <UpdateExtraItemForm
            initialValues={{
            productId: numericProductId,
            additional_price: extra.additionalPrice,
            languages: [
                { languageCode: "en", name: enName },
                { languageCode: "ar", name: arName },
            ],
            }}
            id={extra.id}
            onSubmitSuccess={() => setIsOpen(false)}
            storeId={numericStoreId}
        />
        </CustomModal>

    </div>
  );
}

export default ExtraItemBox;
